import { AlertTriangle, Info, Truck } from 'lucide-react';

export default function SummaryPanel({
  selectedCount,
  totalUnits,
  invalidQtyCount,
  outSelected,
  lowSelected,
  sufficientSelected,
  negativeStockSelected,
  productSuppliers,
  preferredSupplier,
}) {
  const hasSupplier = (productSuppliers || []).length > 0;

  return (
    <div className="rounded-xl border border-neutral-200 bg-neutral-50 p-3 dark:border-neutral-700 dark:bg-neutral-800/35">
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="font-semibold text-neutral-900 dark:text-neutral-100">{selectedCount} variants selected</span>
        <span className="text-neutral-300 dark:text-neutral-600">•</span>
        <span className="font-semibold text-neutral-900 dark:text-neutral-100">{totalUnits} total units</span>
        <div className="ml-auto flex flex-wrap gap-1.5">
          {outSelected > 0 && <span className="rounded-full bg-red-100 px-2 py-1 font-medium text-red-700 dark:bg-red-950/50 dark:text-red-300">{outSelected} out</span>}
          {lowSelected > 0 && <span className="rounded-full bg-amber-100 px-2 py-1 font-medium text-amber-700 dark:bg-amber-950/50 dark:text-amber-300">{lowSelected} low</span>}
          {sufficientSelected > 0 && <span className="rounded-full bg-emerald-100 px-2 py-1 font-medium text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300">{sufficientSelected} sufficient</span>}
        </div>
      </div>

      <div className="mt-3 space-y-2">
        {invalidQtyCount > 0 && (
          <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-2 text-xs text-red-700 dark:border-red-800 dark:bg-red-950/30 dark:text-red-300">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            <span>{invalidQtyCount} selected variant(s) have invalid quantity. Minimum is 1.</span>
          </div>
        )}

        {negativeStockSelected > 0 && (
          <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-2 text-xs text-red-700 dark:border-red-800 dark:bg-red-950/30 dark:text-red-300">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            <span>{negativeStockSelected} selected variant(s) have negative stock. Inventory adjustment may be required.</span>
          </div>
        )}

        {sufficientSelected > 0 && (
          <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-2 text-xs text-amber-700 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-300">
            <Info className="mt-0.5 h-4 w-4 shrink-0" />
            <span>{sufficientSelected} selected variant(s) are already above threshold. Verify if this is proactive replenishment.</span>
          </div>
        )}

        {!hasSupplier ? (
          <div className="flex items-start gap-2 rounded-lg border border-neutral-200 bg-neutral-50 p-2 text-xs text-neutral-600 dark:border-neutral-700 dark:bg-neutral-900/30 dark:text-neutral-300">
            <Truck className="mt-0.5 h-4 w-4 shrink-0" />
            <span>
              No suppliers linked to this product. PR can still be created, but RFQ or supplier linking is required before PO issuance.
            </span>
          </div>
        ) : (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-2 text-xs text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-300">
            Supplier readiness: {productSuppliers.length} linked{preferredSupplier ? `, preferred: ${preferredSupplier.name}` : ''}.
          </div>
        )}
      </div>
    </div>
  );
}
